import axios from 'axios';
import AccessToken from '@/services/auth';
import signature from '@/services/signature';

const ACCESS_TOKEN = AccessToken();
const BASE_URI = process.env.VUE_APP_API_BASE_URI;

let config = {
	headers: {
		Authorization: 'Bearer ' + ACCESS_TOKEN.token,
		TimeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
	}
};

class DashboardApi {
	async get(params = {}) {
		try {
			const query = new URLSearchParams();
			if (params.branch_id !== undefined && params.branch_id !== null && params.branch_id !== 'all') {
				query.append('branch_id', params.branch_id);
			}
			if (params.start) {
				query.append('start', params.start);
			}
			if (params.end) {
				query.append('end', params.end);
			}
			const queryString = query.toString();
			const response = await axios.get(BASE_URI + '/v1/dashboard' + signature(queryString), config);
			return response;
		} catch (err) {
			throw err;
		}
	}
}

export const Dashboard = new DashboardApi();
